import '../css/style.scss'

// import { TriPoint } from './modules/TriPoint.js'
const onReady = () => {
  if (location.hostname === 'localhost' || location.hostname.includes('.local')) {
    document.body.classList.add('localhost')
  }
  // const triPoint = new TriPoint()
}
if (document.readyState !== 'loading') {
  onReady()
} else {
  document.addEventListener('DOMContentLoaded', onReady)
}
